//icons
import "bootstrap-icons/font/bootstrap-icons.css";
import "remixicon/fonts/remixicon.css";

//bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

//font awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import "./App.css";
import Header from "./components/navigation/Header";
import SideBar from "./components/side-navigation/SideBar";

//router
import {
  BrowserRouter,
  Route,
  Routes,
  Outlet,
  Navigate,
} from "react-router-dom";

import Dashboard from "./components/profile-management/Dashboard";
import { useGlobalContext } from "./GlobalContext";
import { LoggedUserDetail } from "./service/UserService";
import { useEffect } from "react";

import GenderTable from "./components/settings/GenderTable";
import TableTemplate from "./components/template/TableTemplate";
import FormTemplate from "./components/template/FormTemplate";
import CountryList from "./components/settings/CountryList";
import AddCountry from "./components/settings/AddCountry";
import EditCountry from "./components/settings/EditCountry";
import AddCity from './components/settings/AddCity';
import CityList from "./components/settings/CitiesList";
import StateList from "./components/settings/StateList";
import AddState from "./components/settings/AddState";
import EditState from "./components/settings/EditState";
import EditCity from "./components/settings/EditCity";

import GiftNew from "./components/gift/AddGift";
import GiftList from "./components/gift/ListGift";
import GiftEdit from "./components/gift/EditGift";
import LevelAdd from "./components/level/LevelAdd";
import LevelEdit from "./components/level/LevelEdit";
import LevelList from "./components/level/LevelList";
import AddMember from "./components/members/AddMember";
import ListMember from "./components/members/ListMemberActive";
import ListMemberInActive from "./components/members/ListMemberDeActive";
import ListMemberFree from "./components/members/ListMemberFree";
import MemberEdit from "./components/members/EditMember";
import MemberPasswordUpdate from "./components/members/MemberPasswordUpdate";
import MemberActivate from "./components/members/ActivateMember";
import MemberPermission from "./components/members/PermissionMember";
import EpinPurchaseList from "./components/epinpurchase/EpinPurchaseList";
import EpinList from "./components/epin/EpinList";
import EpinNewPurchase from "./components/epinpurchase/EpinPurchaseAdd";
import BlogCategoryAdd from "./components/blogcategory/BlogCategoryAdd";
import BlogCategoryEdit from "./components/blogcategory/BlogCategoryEdit";
import BlogCategoryList from "./components/blogcategory/BlogCategoryList";
import BlogAdd from "./components/blog/AddBlog";
import EditBlog from "./components/blog/EditBlog";
import ListBlog from "./components/blog/ListBlog";
import PageNew from "./components/page/AddPage";
import PageEdit from "./components/page/EditPage";
import PageList from "./components/page/ListPage";
import LevelReport from "./components/reports/LevelReport";
import LevelMemberReport from "./components/reports/LevelMemberReport";
import LevelMemberPendingReport from "./components/reports/LevelMemberPendingReport";
import LevelMemberCompletedReport from "./components/reports/LevelMemberCompletedReport";
import UpdateStatusUserLevel from "./components/userLevel/UpdateStatusUserLevel";
import GridBlog from "./components/blog/GridBlog";
import ViewBlog from "./components/blog/ViewBlog";
import ViewPage from "./components/page/ViewPage";


import Login from "./components/general/Login";
import MyProfile from "./components/profile-management/MyProfile";
import MyPassword from "./components/profile-management/MyPassword";
import MatrixGenealogyTree from "./components/genealogy/MatrixGenealogyTree";

function App() {
  library.add(fas);

  const {
    isLoading,
    setIsLoading,
    isAppError,
    setAppError,
    appErrorMessage,
    setAppErrorMessage,
    appErrorTitle,
    setAppErrorTitle,
    appErrorMode,
    setAppErrorMode,
    appUser,
    setAppUser,
    isLogin,
    setIsLogin,
    isLogoutRequest,
    setIsLogoutRequest,
  } = useGlobalContext();

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        setIsLoading(true);
        const response = await LoggedUserDetail();
        if (response.status === 200) {
          setAppUser(response.user);
          setIsLogin(true);
        }
      } catch (error) {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage("Failed to load user details");
        setAppErrorMode("error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    document.querySelectorAll("input").forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  }, []);


  const handleRetry = () => {
    setAppError(false); // Close the modal when retry is triggered
  };

  return (
    <>
     {/* loading screen */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {/* Modal Error Message */}
      {isAppError && (
        <div
          className={appErrorMode + " app-error-message modal d-block"} // `d-block` ensures it always displays
          tabIndex="-1"
          role="dialog"
          aria-labelledby="errorModalLabel"
          aria-hidden="true"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }} // Optional backdrop styling
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="errorModalLabel">
                  {appErrorTitle}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleRetry}
                ></button>
              </div>
              <div className="modal-body">
                <p>{appErrorMessage}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {isLogin ? (
        <>
          <main id="main" className="main">
            <BrowserRouter>
              <Header></Header>
              <SideBar></SideBar>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/myprofile" element={<MyProfile />} />
                <Route path="/mypassword" element={<MyPassword />} />

                {/* Settings */}                
                <Route path="/setting/country/list" element={<CountryList />}/>
                <Route path="/setting/country/add" element={<AddCountry />} />
                <Route path="/setting/country/edit/:id" element={<EditCountry />} /> 
                <Route path="/setting/state/list" element={<StateList />} />  
                <Route path="/setting/state/add" element={<AddState />} />
                <Route path="/setting/state/edit/:id" element={<EditState />} />                 
                <Route path="/setting/citys" element={<CityList />} />                
                <Route path="/setting/add" element={<AddCity />} />                 
                <Route path="/setting/city/edit/:id" element={<EditCity />} />


                {/* Template */}
                <Route path="/template/manage" element={<FormTemplate />} />
                <Route path="/template/list" element={<TableTemplate />} />

                {/* Gift */}
                <Route path="/gift/add" element={<GiftNew />} />
                <Route path="/gift/edit/:id" element={<GiftEdit />} />
                <Route path="/gift/list" element={<GiftList />} />

                {/* Level */}
                <Route path="/level/add" element={<LevelAdd />} />
                <Route path="/level/edit/:id" element={<LevelEdit />} />
                <Route path="/level/list" element={<LevelList />} />

                {/* Members */}
                <Route path="/members/add" element={<AddMember />} />
                <Route path="/members/edit/:id" element={<MemberEdit />} />
                <Route path="/members/password/:id" element={<MemberPasswordUpdate />} />
                <Route path="/members/list" element={<ListMember />} />
                <Route path="/members/list/inactive" element={<ListMemberInActive />} />
                <Route path="/members/list/free" element={<ListMemberFree />} />
                <Route path="/members/activate/:id" element={<MemberActivate />} />
                <Route path="/members/permission/:id" element={<MemberPermission />} />

                {/* Epin */}
                <Route path="/epinpurchase/add" element={<EpinNewPurchase />} />
                <Route path="/epinpurchase/list" element={<EpinPurchaseList />} />
                <Route path="/epin/list/:epinPurchaseId" element={<EpinList />} />

                {/* Blog Category */}
                <Route path="/blogcategory/add" element={<BlogCategoryAdd />} />
                <Route path="/blogcategory/edit/:id" element={<BlogCategoryEdit />} />
                <Route path="/blogcategory/list" element={<BlogCategoryList />} />

                {/* Blog */}
                <Route path="/blog/add" element={<BlogAdd />} />
                <Route path="/blog/edit/:id" element={<EditBlog />} />
                <Route path="/blog/list" element={<ListBlog />} />
                <Route path="/blog/list/grid" element={<GridBlog />} />
                <Route path="/blog/view/:id" element={<ViewBlog />} />

                {/* Page */}
                <Route path="/page/add" element={<PageNew />} />
                <Route path="/page/edit/:id" element={<PageEdit />} />
                <Route path="/page/list" element={<PageList />} />
                <Route path="/page/view/:id" element={<ViewPage />} />

                {/* Reports */}
                <Route path="/reports/level" element={<LevelReport />} />
                <Route path="/reports/level/member/:levelId" element={<LevelMemberReport />} />
                <Route path="/reports/level/member/pending/:levelId" element={<LevelMemberPendingReport />} />
                <Route path="/reports/level/member/completed/:levelId" element={<LevelMemberCompletedReport />} />
                <Route path="/reports/level/member/update/:id" element={<UpdateStatusUserLevel />} />

                <Route path="/tree" element={<MatrixGenealogyTree />} />

                {/* 404 Page */}
                <Route path="*"  element={<Dashboard />} />
              </Routes>
              <Outlet></Outlet>
            </BrowserRouter>
          </main>
        </>
      ) : (
        <>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              {/* 404 Page */}
              <Route path="*" element={<Login />} />
            </Routes>
            <Outlet></Outlet>
          </BrowserRouter>
        </>
      )}

    </>
  );
}

export default App;
